import { render, staticRenderFns } from "./orderConfirm.vue?vue&type=template&id=ea56bce8&scoped=true&"
import script from "./orderConfirm.vue?vue&type=script&lang=js&"
export * from "./orderConfirm.vue?vue&type=script&lang=js&"
import style0 from "./orderConfirm.vue?vue&type=style&index=0&id=ea56bce8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea56bce8",
  null
  
)

export default component.exports